import o from "../../../../../@babel_runtime@7.25.6/node_modules/@babel/runtime/helpers/esm/extends.js";
import u from "vue";
var p = ["ref", "key", "style", "class", "attrs", "refInFor", "nativeOn", "directives", "staticClass", "staticStyle"],
  d = {
    nativeOn: "on"
  };
function l(n, i) {
  var r = p.reduce(function (t, e) {
    return n.data[e] && (t[d[e] || e] = n.data[e]), t;
  }, {});
  return i && (r.on = r.on || {}, o(r.on, n.data.on)), r;
}
function v(n, i) {
  for (var r = arguments.length, t = new Array(r > 2 ? r - 2 : 0), e = 2; e < r; e++) t[e - 2] = arguments[e];
  var a = n.listeners[i];
  a && (Array.isArray(a) ? a.forEach(function (s) {
    s.apply(void 0, t);
  }) : a.apply(void 0, t));
}
function m(n, i) {
  var r = new u({
    el: document.createElement("div"),
    props: n.props,
    render: function render(e) {
      return e(n, o({
        props: this.$props
      }, i));
    }
  });
  return document.body.appendChild(r.$el), r;
}
export { v as emit, l as inherit, m as mount };
